"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  EMAIL: 'notification-type-email',
  SMS: 'notification-type-sms',
  PUSH_NOTIFICATION: 'notification-type-pn'
};
exports.default = _default;